import { spacing } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import styled from 'styled-components/native';

interface Props<T> {
  section: T;

  expanded?: boolean;

  hide_chevron?: boolean;

  onPress?(section: T): void;

  left?: React.ReactNode;
  right?: React.ReactNode;

  children?: React.ReactNode;

  isSmall?: boolean;
}

export const FormCollapsableSection = <T,>(props: Props<T>) => {
  const {
    onPress,
    expanded,
    hide_chevron,
    left,
    right,
    children,
    isSmall = false,
  } = props;

  const handlePress = () => onPress?.(props.section);

  return (
    <>
      <CollapseControlRow onPress={handlePress} isSmall={isSmall}>
        <Left>{left}</Left>
        <Right>
          <RightContent>
            {right}

            {!hide_chevron ? (
              <FontAwesomeIcon
                icon={`chevron-${expanded ? 'up' : 'down'}`}
                size={22}
              />
            ) : null}
          </RightContent>
        </Right>
      </CollapseControlRow>

      {/* TODO make this a nicer animation */}
      {expanded ? children : null}
    </>
  );
};

const CollapseControlRow = styled.TouchableOpacity<{ isSmall?: boolean }>`
  align-items: center;
  ${({ isSmall = false }) =>
    !isSmall
      ? `flex-direction: row;`
      : `
    flex-direction: column;
    gap: ${spacing[4]}px;
    min-height: 44px;
  `}
`;

const Left = styled.View`
  flex: 1;
`;

const Right = styled.View`
  flex-direction: row;
  flex: 1;
  justify-content: flex-end;
`;

const RightContent = styled.View`
  flex-direction: row;
  align-items: center;
  gap: 16px;
`;
